<template>
  <div class="special-request">
    <h2 class="block-title">{{$_('special_request')}}</h2>


    <div class="form-request">
      <div class="form-field">
        <textarea @input="vSetStore('tds', $event.target.value)"></textarea>
      </div>
      <div class="form-field">
        <label>{{$_('mail_special_request')}}</label>
        <Input 
          class="input-email" 
          :type="'email'" 
          :maxlength="70"
          @typing="vSetStore('tmailds', $event)" />
      </div>
      <div class="request-manager">
        <div class="form-field">
          <input
            type="checkbox"
            class="checkbox"
            :id="'request_ac'"
            @change="vSetStoreHeader('ttop_ac', $event.target.checked === true ? 1 : 0)"
          />
          <label :for="'request_ac'">AC</label>
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            class="checkbox"
            :id="'request_adv'"
            @change="vSetStoreHeader('ttop_adv', $event.target.checked === true ? 1 : 0)"
          />
          <label :for="'request_adv'">ADV</label>
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            class="checkbox"
            :id="'request_cda'"
            @change="vSetStoreHeader('ttop_cda', $event.target.checked === true ? 1 : 0)"
          />
          <label :for="'request_cda'">CDA</label>
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            class="checkbox"
            :id="'request_rdv'"
            @change="vSetStoreHeader('ttop_rdv', $event.target.checked === true ? 1 : 0)"
          />
          <label :for="'request_rdv'">RDV</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/common/components/widget/Input/Input";

export default {
  name: "FormRequest",
  components: {
    Input
  },
  methods: {
    vSetStore(key, value) {

      if(key === 'tmailds') {
        value = value.toUpperCase()
      }
      this.$store.dispatch("echantillon/SET_SPECIAL_REQUEST", { key, value });
    },
    vSetStoreHeader(key, value) {
      this.$store.dispatch("echantillon/SET_HEADER", { key, value });
    }
  }
};
</script>

<style scoped>
.form-request {
  display: flex;
  align-items: flex-end;
}
.form-request .form-field:not(:last-child) {
  flex: 1;
  margin-right: 25px;
}
.request-manager {
  display: flex;
}
/deep/
.input-email input {
  min-width: 100%;
  text-transform: uppercase;
}
@media screen and (max-width: 800px) {
  .form-request {
    flex-direction: column;
    align-items: center;
  }
  .form-request .form-field:not(:last-child) {
    flex: 1;
    margin-right: 0px;
  }
  .request-manager .form-field {
    margin: 0px 15px;
  }
}
</style>